<template>
  <div class="share_popup">
    <b-modal
      ok-only
      ok-title="Fermer"
      id="share-popup"
      ref="share-popup"
      title="Partager la formation"
    >
      <!-- partage par email -->
      <h6>Par email</h6>
      <b-input-group>
        <b-input-group-prepend is-text>
          <font-awesome-icon :icon="['far', 'envelope']" />
        </b-input-group-prepend>
        <b-form-input
          type="email"
          v-model="email"
          v-on:keyup.enter="shareViaEmail"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            variant="success"
            @click="shareViaEmail"
            :disabled="emailSending.isSending"
          >
            <font-awesome-icon icon="paper-plane" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <br />
      <b-alert
        :show="emailSending.emailRes"
        :variant="emailSending.alertVariant"
        >{{ emailSending.alertMsg }}</b-alert
      >
      <hr />
      <!-- partage par lien - à copier -->
      <h6>Lien direct</h6>
      <b-input-group>
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="link" />
        </b-input-group-prepend>
        <b-form-input
          v-model="url"
          type="text"
          :value="url"
          disabled
          id="share_url"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            variant="success"
            v-clipboard:copy="url"
            v-clipboard:success="onCopy"
          >
            Copier
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>
  </div>
</template>

<script>
import MailService from "@/services/MailService";

export default {
  name: "SharePopup",
  data() {
    return {
      email: "",
      url: window.location.href,
      emailSending: {
        isSending: false,
        emailRes: false,
        alertVariant: "success",
        alertMsg: "Lien partagé ! (Pensez à vérifier vos spams)",
      },
    };
  },
  mounted() {
    this.mailService = new MailService();
  },
  methods: {
    /**
     * Share the link via the typed email
     */
    shareViaEmail() {
      if (
        this.mailService.isEmailFormatCorrect(this.email) &&
        !this.emailSending.isSending
      ) {
        this.emailSending.isSending = true;
        this.mailService
          .shareUrlViaEmail(this.url, this.email)
          .then(() => {
            this.emailSending.isSending = false;
            this.emailSending.emailRes = true;
            this.emailSending.alertVariant = "success";
            this.emailSending.alertMsg = "Lien partagé ! (Pensez à vérifier vos spams)";
          })
          .catch(() => {
            this.emailSending.isSending = false;
            this.emailSending.emailRes = true;
            this.emailSending.alertVariant = "danger";
            this.emailSending.alertMsg = "Une erreur s'est produite";
          });
      } else {
        //email format incorrect
        this.emailSending.isSending = false;
        this.emailSending.emailRes = true;
        this.emailSending.alertVariant = "danger";
        this.emailSending.alertMsg = "Le format de l'email est incorrect";
      }
    },
    // display a toast when text has been copied
    onCopy: function() {
      this.$bvToast.toast(` `, {
        title: "Texte copié dans le presse-papiers.",
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
